import React, { useState } from 'react';
import { BackendURL } from '../utils/BackendURL'
import axios from 'axios';

const FranchiseForm = () => {
    const [formData, setFormData] = useState({
        fullname: '',
        email: '',
        phone: '',
        currentBusiness: '',
        occupation: '',
        mailingAddress: '',
        franchiseArea: '',
        bestTimeToContact: '',
        message: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log(formData)
            const res = await axios.post(`${BackendURL}/franchise`, formData);
            console.log(res.data);
        } catch (error) {
            console.error("Error:", error.message);
        }
    };

    return (
        <div className="franchise-form-container">
            <form action="/submit-form" method="post" onSubmit={handleSubmit} className="franchise-form">
                <label htmlFor="franchise-fullName" className="franchise-form-label">Full Name:</label>
                <input type="text" id="franchise-fullName" name="fullname" required onChange={handleChange} className="franchise-form-input" />
                <br /><br />

                <label htmlFor="franchise-email" className="franchise-form-label">Email:</label>
                <input type="email" id="franchise-email" name="email" required onChange={handleChange} className="franchise-form-input" />
                <br /><br />

                <label htmlFor="franchise-phone" className="franchise-form-label">Phone:</label>
                <input type="tel" id="franchise-phone" name="phone" required onChange={handleChange} className="franchise-form-input" /><br /><br />

                <label htmlFor="franchise-currentBusiness" className="franchise-form-label">Current Business:</label>
                <input type="text" id="franchise-currentBusiness" name="currentBusiness" onChange={handleChange} className="franchise-form-input" /><br /><br />

                <p>Occupation:</p>
                <input type="radio" id="franchise-retired" name="occupation" value="Retired Person" onChange={handleChange} className="franchise-radio-input" />
                <label htmlFor="franchise-retired">Retired Person</label><br />

                <input type="radio" id="franchise-salaryPerson" name="occupation" value="Salary Person" onChange={handleChange} className="franchise-radio-input" />
                <label htmlFor="franchise-salaryPerson">Salary Person</label><br />

                <input type="radio" id="franchise-businessPerson" name="occupation" value="Business Person" onChange={handleChange} className="franchise-radio-input" />
                <label htmlFor="franchise-businessPerson">Business Person</label><br /><br />

                <label htmlFor="franchise-mailingAddress" className="franchise-form-label">Post Mailing Address:</label>
                <textarea id="franchise-mailingAddress" name="mailingAddress" onChange={handleChange} className="franchise-form-input"></textarea><br /><br />

                <label htmlFor="franchise-franchiseArea" className="franchise-form-label">Chosen or Desired Area For Franchise:</label>
                <input type="text" id="franchise-franchiseArea" name="franchiseArea" onChange={handleChange} required className="franchise-form-input" />
                <br /><br />

                <label htmlFor="franchise-bestTimeToContact" className="franchise-form-label">Best Time to Contact You:</label>
                <input type="text" id="franchise-bestTimeToContact" name="bestTimeToContact" onChange={handleChange} className="franchise-form-input" /><br /><br />

                <label htmlFor="franchise-message" className="franchise-form-label">Message:</label>
                <textarea id="franchise-message" name="message" onChange={handleChange} className="franchise-form-input"></textarea><br /><br />

                <input type="submit" value="Submit" className="franchise-submit-button" />
            </form>
        </div>
    );
};

export default FranchiseForm;

